var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.value,"icon":"org_icon_role","destructive":true,"headline":"Delete Role","actionLabel":"Delete","htmlInfo":_vm.info,"hasDraftsRes":_vm.hasDrafts,"applyBorderClass":true},on:{"onAction":function($event){return _vm.$emit('onDelete', $event)},"input":function($event){return _vm.$emit('input', false)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }